import { render, staticRenderFns } from "./index.vue.js?vue&type=template&id=2bffa846&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2bffa846&scoped=true"
import script from "./index.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&lang=js"
export * from "./index.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue.scss?vue&type=style&index=0&id=2bffa846&lang=scss&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=2bffa846&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bffa846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bffa846')) {
      api.createRecord('2bffa846', component.options)
    } else {
      api.reload('2bffa846', component.options)
    }
    module.hot.accept("./index.vue.js?vue&type=template&id=2bffa846&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2bffa846&scoped=true", function () {
      api.rerender('2bffa846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TrainVideo/index.vue"
export default component.exports